<div>
  <div class="col-md-12 d-flex align-items-center justify-content-center mt-3">
    @if (isAllowedToFilterByStateActive) {
      <i-tabs class="box" [items]="activeStates" (tabChange)="filterItems($event)" [align]="'center'"> </i-tabs>
    }
    @if (isAllowedToFilterByStateActiveCustom) {
      <i-tabs class="box" [items]="activeStates" (tabChange)="filterCustomActive($event)" [align]="'center'"> </i-tabs>
    }
  </div>
  <p-table
    #dt
    [value]="lists"
    [columns]="columns"
    [responsive]="true"
    [rows]="rowsToShow"
    [scrollHeight]="height"
    [scrollable]="true"
    [totalRecords]="totalRecords"
    class="super-compos-table"
    dataKey="name"
    [paginator]="true"
    (onLazyLoad)="layLoadData($event)"
    [lazy]="true"
    [loading]="loading">
    <ng-template pTemplate="caption">
      <div class="row mt-2">
        <div class="p-fluid" class="col-6">
          <input
            class="form-control w-100"
            pInputText
            type="text"
            #search
            (keyup)="searchList(search.value)"
            placeholder="Rechercher dans la liste" />
        </div>
        @if (typeContact?.length > 0) {
          <div class="col-6">
            <p-dropdown
              styleClass="w-100"
              [options]="typeContact | sort: 'label' : 'ASC'"
              baseZIndex="1000"
              placeholder="Rechercher via un type de contact"
              [showClear]="true"
              appendTo="body"
              [(ngModel)]="searchTypeContact"
              (onChange)="filter('typeContactID', searchTypeContact, 'userActive', activeStateRecipient)"
              id="searchByTypeContact">
            </p-dropdown>
          </div>
        }
        @if (listServices && listServices.length > 0 && typeOfContact === 'user') {
          <div class="col-6 p-fluid">
            <!-- <p-dropdown styleClass="w-100" [options]="listServices|sort:'label':'ASC'" baseZIndex="1000"
              placeholder="Rechercher via un service" [showClear]="true" appendTo="body"
              [(ngModel)]="searchTypeContact" (onChange)="filterByService($event)" id='searchByTypeContact'>
            </p-dropdown> -->
            <p-treeSelect
              [emptyMessage]="'noResultFound' | translate"
              [options]="listServices"
              #treeSelect
              selectionMode="single"
              [placeholder]="'pleaseSelectAService' | translate"
              appendTo="body"
              (onNodeSelect)="filterByService($event)"
              [filter]="true"
              [filterPlaceholder]="'global.filterPlaceholder' | translate"
              [filterBy]="'label'"
              [filterMode]="'strict'"
              [metaKeySelection]="false"></p-treeSelect>
          </div>
        }
        @if (lists && lists.length === 0) {
          <div class="col-md-12 mt-3">
            <div class="alert alert-primary">Il n'y a pas de résultats pour votre recherche</div>
          </div>
        }
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      @if (boolShowHeader) {
        <tr>
          @for (col of columns; track col; let i = $index) {
            <th [id]="col.field" [pSortableColumn]="col.field">
              {{ col.header }}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          }
        </tr>
      }
    </ng-template>
    <ng-template pTemplate="body" let-columns="columns" let-item let-expanded="expanded">
      <tr [ngClass]="{ 'active-line': activeLine === item.id }" (click)="toggleLine(item); fct(item)">
        @if (boolMultiSelect) {
          <td class="tdCheckboxWidth">
            <label class="containerc mb-0">
              <input type="checkbox" (change)="selectItem($event, item)" [(ngModel)]="item.checked" />
              <span
                class="checkmark d-block position-relative"
                [ngClass]="{ 'checkmark-gray': !item.checked, 'checkmark-gray-checked': item.checked }"></span>
            </label>
          </td>
        }
        @for (col of columns; track col; let last = $last) {
          <td>
            <div class="tdApList" [ngClass]="{ 'text-right': last && alignLast === 'right' }">
              @if (typeOfContact && typeOfContact === 'contact' && col.field === 'name') {
                <span>
                  <span>{{ item[col.field] }}</span>
                </span>
              } @else {
                {{ item[col.field] }}
              }
            </div>
          </td>
        }
      </tr>
    </ng-template>
  </p-table>
</div>
